import React from 'react';

import {HelpCenterNavigationCard, mobileOnly} from '@aboutyou/ui-components';
import styled, {css} from 'styled-components';
import {GetSelfServiceFlowSectionResponse} from '../types';

interface SelfServiceFlowSectionViewProps {
  section: GetSelfServiceFlowSectionResponse['section'];
  noDescription?: boolean;
}

export const SelfServiceFlowSectionView = ({
  section,
  noDescription = false,
}: SelfServiceFlowSectionViewProps) => {
  return (
    <LinksContainer>
      {section.children.map(child => (
        <HelpCenterNavigationCard
          key={child.id}
          url={child.nextLink.url}
          title={child.title}
          iconUrl={child.icon?.url}
        >
          {noDescription ? undefined : child.description}
        </HelpCenterNavigationCard>
      ))}
    </LinksContainer>
  );
};

const LinksContainer = styled.div`
  max-width: 430px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${mobileOnly(
    css`
      gap: 10px;
    `,
  )}
`;
